export class BudgetInventory {
  id: any;
  periodId: any;
  partnerId: any;
  status: any;
  type:any;
}
